import { createFileRoute } from '@tanstack/react-router';
import { UiGallery } from '../features/dev/UiGallery.tsx';

/** Hidden gallery of the UI primitives (not linked anywhere; used by e2e). */
export const Route = createFileRoute('/dev/ui')({ component: UiGallery });
